import{a as l}from"./chunk.2AIXLGYE.js";import{a as e}from"./chunk.NFEB7TIJ.js";import{a as t}from"./chunk.XPINZPW5.js";import{a}from"./chunk.65JZXZ5X.js";import{c as r}from"./chunk.NWIV65VP.js";import{html as s}from"lit";import{property as i,state as n}from"lit/decorators.js";import{classMap as h}from"lit/directives/class-map.js";import{css as c}from"lit";var d=c`
  ${l}

  :host {
    --radio-size: var(--he-form-control-toggle-size);

    display: block;
  }

  :host(:focus-visible) {
    outline: 0px;
  }

  .radio {
    display: inline-flex;
    align-items: top;
    font-family: var(--he-form-control-font-family);
    font-size: var(--he-form-control-font-size);
    font-weight: var(--he-font-weight-normal);
    color: var(--he-form-control-color);
    vertical-align: middle;
    cursor: pointer;
  }

  .radio__icon {
    display: inline-flex;
    width: var(--radio-size);
    height: var(--radio-size);
  }

  .radio__icon svg {
    width: 100%;
    height: 100%;
  }

  .radio__control {
    flex: 0 0 auto;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--radio-size);
    height: var(--radio-size);
    border: var(--he-form-control-border-width) solid var(--he-form-control-toggle-border-color);
    border-radius: 50%;
    background-color: var(--he-neutral-fill-stealth-rest);
    color: transparent;
  }

  .radio__input {
    position: absolute;
    opacity: 0;
    padding: 0;
    margin: 0;
    pointer-events: none;
  }

  /* Hover */
  .radio:not(.radio--checked):not(.radio--disabled):hover .radio__control {
    background-color: var(--he-neutral-fill-stealth-hover);
  }

  /* Active */
  .radio:not(.radio--checked):not(.radio--disabled):active .radio__control {
    background-color: var(--he-neutral-fill-stealth-active);
  }

  /* Checked */
  .radio--checked .radio__control {
    color: var(--he-accent-fill-rest);
    border-color: var(--he-accent-fill-rest);
    background-color: var(--he-color-neutral-0);
  }

  /* Checked + hover */
  .radio.radio--checked:not(.radio--disabled):hover .radio__control {
    color: var(--he-accent-fill-hover);
    border-color: var(--he-accent-fill-hover);
    background-color: var(--he-color-neutral-0);
  }

  /* Checked + active */
  .radio.radio--checked:not(.radio--disabled):active .radio__control {
    color: var(--he-accent-fill-active);
    border-color: var(--he-accent-fill-active);
    background-color: var(--he-color-neutral-0);
  }

  /* Checked + focus */
  :host(:focus-visible) .radio {
    outline: solid var(--he-focus-ring-width) var(--he-form-control-toggle-focus-ring-color);
    outline-offset: 1px;
  }

  /* Disabled */
  .radio--disabled {
    cursor: not-allowed;
  }

  .radio--disabled .radio__label {
    color: var(--he-type-disabled);
  }

  .radio--disabled .radio__control {
    border-color: var(--he-form-control-disabled-background);
  }

  /* Checked + Disabled */
  .radio--checked.radio--disabled .radio__control {
    color: var(--he-form-control-disabled-background);
    border-color: var(--he-form-control-disabled-background);
  }

  /* When the control isn't checked, hide the circle for Windows High Contrast mode a11y */
  .radio:not(.radio--checked) svg circle {
    opacity: 0;
  }

  .radio__label {
    color: var(--he-form-control-color);
    line-height: var(--radio-size);
    margin-inline-start: 0.5em;
    user-select: none;
  }

  /* High contrast */
  @media screen and (forced-colors: active) {
    .radio__control {
      border-color: ${e.ButtonText};
      background: ${e.ButtonFace};
    }

    /* Hover */
    .radio:not(.radio--checked):not(.radio--disabled):hover .radio__control,
    .radio:not(.radio--checked):not(.radio--disabled):active .radio__control {
      outline: ${e.ButtonText} solid 2px;
      outline-offset: -3px;
    }

    /* Checked */
    .radio--checked .radio__control {
      color: ${e.Highlight};
      border-color: ${e.Highlight};
      background-color: ${e.HighlightText};
    }

    /* Disabled */
    .radio--disabled {
      opacity: 1;
    }

    .radio--disabled .radio__label {
      color: ${e.GrayText};
    }

    .radio--disabled .radio__control {
      border-color: ${e.GrayText};
      background-color: ${e.Canvas};
    }

    /* Checked + Disabled */
    .radio--checked.radio--disabled .radio__control {
      color: ${e.GrayText};
      border-color: ${e.GrayText};
      background-color: ${e.Canvas};
    }
  }
`;var o=class extends a{constructor(){super(...arguments);this.hasFocus=!1;this.checked=!1;this.disabled=!1}connectedCallback(){super.connectedCallback(),this.setInitialAttributes(),this.addEventListeners()}handleCheckedChange(){this.setAttribute("aria-checked",this.checked?"true":"false"),this.setAttribute("tabindex",this.checked?"0":"-1"),this.checked&&this.emit("he-selected")}handleDisabledChange(){this.setAttribute("aria-disabled",this.disabled?"true":"false")}handleBlur(){this.hasFocus=!1,this.emit("he-blur")}handleClick(){this.disabled||(this.checked=!0)}handleFocus(){this.hasFocus=!0,this.emit("he-focus")}addEventListeners(){this.addEventListener("blur",()=>this.handleBlur()),this.addEventListener("click",()=>this.handleClick()),this.addEventListener("focus",()=>this.handleFocus())}setInitialAttributes(){this.setAttribute("role","radio"),this.setAttribute("tabindex","-1"),this.setAttribute("aria-disabled",this.disabled?"true":"false")}render(){return s`
      <span
        part="base"
        class=${h({radio:!0,"radio--checked":this.checked,"radio--disabled":this.disabled,"radio--focused":this.hasFocus})}
      >
        <span part="control" class="radio__control">
          <svg part="checked-icon" class="radio__icon" viewBox="0 0 12 12">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g fill="currentColor">
                <circle cx="6" cy="6" r="3.42857143"></circle>
              </g>
            </g>
          </svg>
        </span>

        <span part="label" class="radio__label">
          <slot></slot>
        </span>
      </span>
    `}};o.styles=d,o.baseName="radio",o.reactEvents={onHeBlur:new CustomEvent("he-blur"),onHeFocus:new CustomEvent("he-focus"),onHeSelected:new CustomEvent("he-selected")},r([n()],o.prototype,"hasFocus",2),r([i({type:Boolean,reflect:!0})],o.prototype,"checked",2),r([i()],o.prototype,"value",2),r([i({type:Boolean,reflect:!0})],o.prototype,"disabled",2),r([t("checked")],o.prototype,"handleCheckedChange",1),r([t("disabled",{waitUntilFirstUpdate:!0})],o.prototype,"handleDisabledChange",1);var x=o;export{o as a,x as b};
